import Login from './Login';
import Home from './Home';

const messages = {
  en: {
    当前语言: 'English',
    即时通信: 'IM',
    即时通信IM: 'IM',
    社交娱乐: 'Entertaining & Socializing',
    旭牧通: 'Tencent Cloud',
    使用指引: 'User Guide',
    Login,
    Home,
  },
};

export default messages;
